import {NgModule} from '@angular/core';
import {CommonModule} from '@angular/common';
import {HomeRoutingModule} from './home-routing.module';
import {HomepageComponent} from './homepage/homepage.component';
import {SharedModule} from '../shared/shared.module';
import {SwiperModule} from 'ngx-swiper-wrapper';
import {CarouselsResolver} from "./services/carousels.resolver";
import {NewsItemsResolver} from "../news/services/news-items.resolver";

@NgModule({
    declarations: [
        HomepageComponent
    ],
    imports: [
        CommonModule,
        HomeRoutingModule,
        SharedModule,
        SwiperModule
    ],
    providers: [
        CarouselsResolver,
        NewsItemsResolver
    ]
})
export class HomeModule {
}
